module.exports = __webpack_public_path__ + "img/5.41dd9cb1.png";